import React from "react";
import { Container } from "@chakra-ui/react";
import Header from "./Header";
import Main from "./Main";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getTemplate } from "../../redux/actions/templateActions";

const Dashboard = ({ currentTemplate, formTitle }) => {
  return (
    <Container w="100%" h="100%" maxW="100%" m="auto">
      {/* header */}
      <Header template={currentTemplate} formTitle={formTitle} />
      {/* main */}
      <Main />
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    currentTemplate: state.templates.currentTemplate,
    formTitle: state.form.title,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatchGetTemplate: bindActionCreators(getTemplate, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
